export default ({ touched, valid }) =>
  [
    'form-control',
    touched && !valid ? 'is-invalid' : '',
    touched && valid ? 'is-valid' : ''
  ].join(' ');



// WEBPACK FOOTER //
// ./src/Bootstrap/get-input-class.js